import { useMemo } from 'react';
import { Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import RevampBedStatusIcon from '../../components/RevampBedStatusIcon';
import { BedStatusIcon } from '../../components';

const LandingBed = ({
  data,
  updateBedStatus,
  saveBedStatus,
  saveReturnDayCase,
  getFloorPlanListAPI,
  readOnly = false,
  showPatientName,
  isMutipleWardCode,
}) => {
  const { isCubicleV2 } = useSelector((state) => state.bedStatusView);
  const BedIconComponent = useMemo(() => {
    return isCubicleV2 ? RevampBedStatusIcon : BedStatusIcon;
  }, [isCubicleV2]);

  return data ? (
    <Box width="5rem" height="4.688rem" pt={isCubicleV2 ? '0' : '1.563rem'}>
      <BedIconComponent
        isAbsolute={true}
        allData={data}
        status={data.status}
        updateBedStatus={updateBedStatus}
        bedNo={data.bedNo}
        gender={data.patGender}
        saveBedStatus={saveBedStatus}
        saveReturnDayCase={saveReturnDayCase}
        ward={data.ccWardCd}
        reload={getFloorPlanListAPI}
        disabled={readOnly}
        showPatientName={showPatientName}
        isMutipleWardCode={isMutipleWardCode}
      />
    </Box>
  ) : (
    <Box display="flex" alignItems="center" justifyContent="center" width="5rem" height="4.688rem" />
  );
};

export default LandingBed;
